import styled from "styled-components";

export const ProductsWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 20px;
    row-gap: 10px;
    
    @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const ProductCard = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;